import { useEffect } from 'react';
import type { NotificationType } from '../providers/NotificationProvider';
import { useAuth } from '../providers/SupabaseProvider';

export function useNotificationWebSocket(
  addNotification: (message: string, type?: NotificationType, options?: NotificationOptions) => void
) {
  const { user } = useAuth();

  useEffect(() => {
    const url = import.meta.env.VITE_WS_NOTIFICATIONS_URL;
    if (!user || !url) return;

    const ws = new WebSocket(`${url}?userId=${user.id}`);

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        addNotification(data.title || data.message || 'Neue Benachrichtigung', data.type);
      } catch (e) {
        console.error('Failed to parse notification', e);
      }
    };

    ws.onerror = (e) => {
      console.error('WebSocket error', e);
    };

    return () => {
      ws.close();
    };
  }, [user, addNotification]);
}

